import { useTranslate } from "ra-core";
import { useEffect, useState } from "react";
import { Link } from "react-router";
import { useDialerApi } from "./api/DialerApiContext";

const POLL_MS = 30_000;

/** Top bar « Appel en cours » pill (spec 10 §4): polls the DialerApi for an open session. */
export const SessionPill = () => {
  const translate = useTranslate();
  const api = useDialerApi();
  const [active, setActive] = useState(false);
  useEffect(() => {
    let alive = true;
    const check = () =>
      api
        .getActiveSession()
        .then((s) => alive && setActive(s !== null))
        .catch(() => undefined);
    void check();
    const timer = setInterval(check, POLL_MS);
    return () => {
      alive = false;
      clearInterval(timer);
    };
  }, [api]);
  if (!active) return null;
  return (
    <Link
      to="/appeler"
      className="inline-flex items-center gap-2 rounded-full border border-primary bg-accent px-3 py-1 text-xs font-bold text-accent-foreground"
    >
      <span
        className="size-2 rounded-full bg-primary motion-safe:animate-pulse"
        aria-hidden="true"
      />
      {translate("gavion.nav.call_in_progress")}
    </Link>
  );
};
